module.exports = __webpack_public_path__ + "static/media/photo-guide.0704f93a.svg";